<template>
  <div class="hello">
    <div class="box">
      <h4>Selecteer project</h4>

      <div class="form-group">
        <label class="zi-title zi-subtitle label w-full" for>Project</label>

        <zi-select v-model="selected">
          <zi-option value label="kies ene project" />
          <zi-option
            :key="project.id"
            v-for="project in _projects"
            :value="project.id"
            :label="project.name_with_namespace"
          />
        </zi-select>

        <p class="zi-subtitle">Kies het project waarmee alle issues opgehaald moet worden.</p>
      </div>

      <div class="form-action">
        <zi-button
          :loading="isLoading"
          :disabled="!hasProjectSelected"
          type="success"
          @click="confirmSelectedProject"
        >kies project</zi-button>
      </div>

      <zi-dialog v-model="isLoading" title="Bezig met laden" :close-by-modal="false" class="without-footer">
        <p class="loader w-full">
          <span>Bezig met laden van alles issues van gekozen project.</span>
          <zi-spinner class="loader--spinner"></zi-spinner>
        </p>
        <zi-progress :percentage="progressPercentage" :show-text="false" class="w-full" />
      </zi-dialog>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'SelectProject',
  beforeRouteEnter (a, b, next) {
    next(vm => {
      if (vm.$store.getters.hasToken && vm.$store.getters.project) {
        vm.$router.push({ name: 'dashboard'})
      } else if (!vm.$store.getters.hasToken) {
        vm.$router.push({ name: 'hello'})
      }
    })
  },
  computed: {
    ...mapState(['_projects']),
    hasProjectSelected() {
      return this.selected !== ''
    },
    selectButtonText() {
      return this.hasProjectSelected ? this.selected : 'kies een project'
    },
    progressPercentage() {
      if (!this.$store.state.progress) {
        return 0
      }
      
      const { total, done } = this.$store.state.progress

      return done / total * 100
    }
  },
  data: () => ({
    selected: '',
    isLoading: false,
  }),
  methods: {
    confirmSelectedProject() {
      this.isLoading = true
      this.$store
        .dispatch('SELECT_PROJECT', { selected: this.selected })
        .then(() => {
          this.$router.push({ name: 'dashboard' })

          this.$Toast.show({
            type: 'success',
            text: `Er zijn ${this.$store.state.progress.total} issues gesyncroniseerd voor dit project.`,
            duration: 4000,
          })
        })
        .finally(() => (this.isLoading = false))
    },
  },
}
</script>

<style scoped>
.label {
  display: block;
}
.popover .dropdown {
  max-height: 200px;
  overflow-y: auto;
}
.loader {
  display: flex;
  align-items: center;
  text-align: center;
}
.loader--spinner {
  margin-left: 10px;
}
.zi-progress {
  width: 100%;
}
</style>